export default answer => {
  const { comments, ...rest } = answer || {};

  return {
    value: { ...rest },
    comments,
  };
};
